/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Status_508Inputs */

const vi_carrier_status_508 = /** @type {(inputs: Carrier_Status_508Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phát tiếp`)
};

/**

* @param {Carrier_Status_508Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_status_508 = /** @type {((inputs?: Carrier_Status_508Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Status_508Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_status_508(inputs)
});